import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator, Linking, Image,Text
} from "react-native";

import {scale, moderateScale, verticalScale} from '../../../tools/Scaling';

import Colors from "../../../tools/Colors";


const {width: SCREEN_WIDTH} = Dimensions.get("window");

const SLIDER_HEIGHT = verticalScale(180);
const HEADER_HEIGHT = Platform.OS === "ios" ? verticalScale(64) : verticalScale(50);
const SCROLL_HEIGHT = SLIDER_HEIGHT - HEADER_HEIGHT;
const THEME_COLOR = Colors.colorPrimary;


import HMTextView from "../../../customviews/HMTextView";
import HMActionBar from "../../../customviews/HMActionBarSatia";
import i18n from "../../../I18n/i18n";

const IS_ANDROID = Platform.OS === 'android';
const SLIDER_1_FIRST_ITEM = 1;


export default class SatiaScreen extends Component {


    constructor(props) {
        super(props);

        this.state = {
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,

            modalHeight: 0,
            ddd: [
                "The min size must be a number.",
                "The min size must be less than 4.",
                "The max size must be a number."
            ]

        };

    }

    componentWillReceiveProps(propss) {

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    componentDidMount() {


    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }

    render() {
        let phone = "08633805"
        let linkUrl = "http://www.satia.me/"
        return (
            <View style={{flex: 1}}>
                <HMActionBar back menu props={this.props} statusBarTransparent text={i18n.t('constant.About_software')} headerVisibility
                             more_menu
                             drawer
                             onBackPress={() => this.props.navigation.pop()}/>
                <View style={{position: 'relative', flex: 1}}>
             {/*       <HMImageBackground

                        background={PathFile.image.backgroundSatia}
                    />*/}

                    <View style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        alignItems: 'center',
                        justifyContent: "center"
                    }}>
                        <View style={{
                            marginTop: moderateScale(24),
                            alignItems: 'center',
                            justifyContent: "center"
                        }}>
                            <TouchableOpacity

                                style={{
                                    margin: moderateScale(3),
                                    //  height:moderateScale(20)
                                }}
                                onPress={() => {
                                    const url = Platform.OS === 'ios' ? `telprompt:${phone}` : `tel://${phone}`;
                                    Linking.canOpenURL(url)
                                        .then((supported) => {
                                            if (supported) {
                                                return Linking.openURL(url)
                                                    .catch(() => null);
                                            }
                                        });
                                }}
                            >
                                <HMTextView
                                    text={"086 33805"}
                                    // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                    type={'bold'}
                                    style={{
                                        // alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        //  textAlign: 'center',

                                        color: Colors.red,
                                        fontSize: moderateScale(16),

                                    }}/>
                            </TouchableOpacity>

                            <TouchableOpacity
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',
                                    margin: moderateScale(3)
                                }}

                                onPress={() => {
                                    Linking.openURL(linkUrl).catch(err => console.error('An error occurred', err))

                                }}

                            >
                                <HMTextView
                                    text={"www.satia.co"}
                                    // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                    type={'bold'}
                                    style={{
                                        // alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        //  textAlign: 'center',
                                        color: Colors.colorSecondPrimary,
                                        fontSize: moderateScale(16),
                                    }}/>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            </View>
        );
    }

}
